/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Video_Analysis_LabelInputs */

const en_doc_video_analysis_label = /** @type {(inputs: Doc_Video_Analysis_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video analysis`)
};

const pt_br2_doc_video_analysis_label = /** @type {(inputs: Doc_Video_Analysis_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise de vídeo`)
};

/**
* | output |
* | --- |
* | "Video analysis" |
*
* @param {Doc_Video_Analysis_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_video_analysis_label = /** @type {((inputs?: Doc_Video_Analysis_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Video_Analysis_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_video_analysis_label(inputs)
	return pt_br2_doc_video_analysis_label(inputs)
});